import { Atom, ATOMS } from "./atoms";
import { Parser } from "./parser";

export class MolecularFormulaParser extends Parser {
    public readAtom(): Atom {
        if (this.isEnd()) {
            throw new Error("Parser: Data ended");
        }

        let atomLetter = this.readAsciiUpper();

        // read all following lowercase letters
        let charCode: number;
        while (
            !this.isEnd() &&
            this.isAsciiLower((charCode = this.data.charCodeAt(this.i)))
        ) {
            atomLetter += String.fromCharCode(charCode);
            ++this.i;
        }

        // find atom
        const atom = ATOMS.find((a) => a.letter === atomLetter);
        if (!atom) {
            throw new Error(
                `MolecularFormulaParser.readAtom: Atom "${atomLetter}" not found`,
            );
        }

        return atom;
    }

    public readAtomWithCount(): { atom: Atom; count: number } {
        const atom = this.readAtom();
        let count = 1;
        if (this.nextIsDigit()) {
            count = this.readInt();
        }

        return { atom, count };
    }
}
